import { estadoCivilPessoaFisicaOptions } from "./dynamicTextRegistry";

const showConjugeWhenCasado = {
  field: "ESTADO_CIVIL_PESSOA_FISICA",
  value: "casado",
};

const pessoaFisicaFields = [
  { id: "NOME_PESSOA_FISICA", label: "Nome", type: "text", required: true },
  {
    id: "CPF_PESSOA_FISICA",
    label: "CPF",
    type: "text",
    required: true,
    mask: "cpf",
  },
  { id: "RG_PESSOA_FISICA", label: "RG", type: "text" },
  { id: "NACIONALIDADE_PESSOA_FISICA", label: "Nacionalidade", type: "text" },
  { id: "PROFISSAO_PESSOA_FISICA", label: "Profissão", type: "text" },
  {
    id: "ESTADO_CIVIL_PESSOA_FISICA",
    label: "Estado civil",
    type: "select",
    required: true,
    options: estadoCivilPessoaFisicaOptions,
    placeholder: "Selecione",
  },
  {
    id: "NOME_CONJUGE",
    label: "Nome do cônjuge",
    type: "text",
    showWhen: showConjugeWhenCasado,
  },
  {
    id: "CPF_CONJUGE",
    label: "CPF do cônjuge",
    type: "text",
    mask: "cpf",
    showWhen: showConjugeWhenCasado,
  },
  {
    id: "RG_CONJUGE",
    label: "RG do cônjuge",
    type: "text",
    showWhen: showConjugeWhenCasado,
  },
  {
    id: "NACIONALIDADE_CONJUGE",
    label: "Nacionalidade do cônjuge",
    type: "text",
    showWhen: showConjugeWhenCasado,
  },
  {
    id: "PROFISSAO_CONJUGE",
    label: "Profissão do cônjuge",
    type: "text",
    showWhen: showConjugeWhenCasado,
  },
  {
    id: "EMAIL_CONJUGE",
    label: "E-mail do cônjuge",
    type: "email",
    required: true,
    showWhen: showConjugeWhenCasado,
  },
  { id: "RUA_ENDERECO_PESSOA_FISICA", label: "Rua", type: "text" },
  { id: "N_ENDERECO_PESSOA_FISICA", label: "Número", type: "text" },
  { id: "BAIRRO_ENDERECO_PESSOA_FISICA", label: "Bairro", type: "text" },
  { id: "MUN_ENDERECO_PESSOA_FISICA", label: "Município", type: "text" },
  { id: "CEP_PESSOA_FISICA", label: "CEP", type: "text" },
  { id: "EMAIL_PESSOA_FISICA", label: "Email", type: "email", required: true },
  {
    id: "TEL_PESSOA_FISICA",
    label: "Telefone",
    type: "text",
    mask: "phone",
  },
];

const autorizacaoVendaImovelFormSchema = [
  {
    sectionId: "proprietarios",
    sectionLabel: "Autorizadores (proprietários)",
    repeatable: true,
    groupKey: "proprietarios",
    minItems: 1,
    fields: [...pessoaFisicaFields],
  },

  {
    sectionId: "intermediador",
    sectionLabel: "Autorizado (intermediador)",
    type: "conditional",
    groupKey: "intermediador",
    requireTypeSelection: true,
    options: {
      corretor: [
        {
          id: "NOME_CORRETOR",
          label: "Nome do corretor",
          type: "text",
          required: true,
        },
        {
          id: "NACIONALIDADE_CORRETOR",
          label: "Nacionalidade",
          type: "text",
          required: true,
        },
        {
          id: "CPF_CORRETOR",
          label: "CPF",
          type: "text",
          required: true,
          mask: "cpf",
        },
        { id: "RG_CORRETOR", label: "RG", type: "text", required: true },
        {
          id: "CRECI_CORRETOR",
          label: "CRECI",
          type: "text",
          required: true,
        },
        {
          id: "RUA_ENDERECO_CORRETOR",
          label: "Rua",
          type: "text",
          required: true,
        },
        {
          id: "N_ENDERECO_CORRETOR",
          label: "Número",
          type: "text",
          required: true,
        },
        {
          id: "BAIRRO_ENDERECO_CORRETOR",
          label: "Bairro",
          type: "text",
          required: true,
        },
        {
          id: "MUN_ENDERECO_CORRETOR",
          label: "Município",
          type: "text",
          required: true,
        },
        {
          id: "CEP_CORRETOR",
          label: "CEP",
          type: "text",
          required: true,
        },
        {
          id: "EMAIL_CORRETOR",
          label: "E-mail",
          type: "email",
          required: true,
        },
        {
          id: "TEL_CORRETOR",
          label: "Telefone",
          type: "text",
          required: true,
          mask: "phone",
        },
      ],
      imobiliaria: [
        {
          id: "RAZAO_SOCIAL_IMOBILIARIA",
          label: "Razão social",
          type: "text",
          required: true,
        },
        {
          id: "CNPJ_IMOBILIARIA",
          label: "CNPJ",
          type: "text",
          required: true,
        },
        {
          id: "INTERM_CRECI_IMOBILIARIA",
          label: "CRECI (autorizado)",
          type: "text",
          required: true,
        },
        {
          id: "NOME_REPRESENTANTE_LEGAL",
          label: "Representante legal",
          type: "text",
          required: true,
        },
        {
          id: "CPF_REPRESENTANTE_LEGAL",
          label: "CPF do representante",
          type: "text",
          required: true,
          mask: "cpf",
        },
        {
          id: "RUA_ENDERECO_IMOBILIARIA",
          label: "Rua",
          type: "text",
          required: true,
        },
        {
          id: "N_ENDERECO_IMOBILIARIA",
          label: "Número",
          type: "text",
          required: true,
        },
        {
          id: "BAIRRO_ENDERECO_IMOBILIARIA",
          label: "Bairro",
          type: "text",
          required: true,
        },
        {
          id: "MUN_ENDERECO_IMOBILIARIA",
          label: "Município",
          type: "text",
          required: true,
        },
        {
          id: "CEP_IMOBILIARIA",
          label: "CEP",
          type: "text",
          required: true,
        },
        {
          id: "INTERM_EMAIL_IMOBILIARIA",
          label: "E-mail (autorizado)",
          type: "email",
          required: true,
        },
        {
          id: "TEL_IMOBILIARIA",
          label: "Telefone",
          type: "text",
          required: true,
          mask: "phone",
        },
      ],
    },
  },

  {
    sectionId: "testemunhas",
    sectionLabel: "Testemunhas",
    repeatable: true,
    groupKey: "testemunhas",
    fields: [
      { id: "NOME_TESTEMUNHA", label: "Nome", type: "text", required: true },
      {
        id: "CPF_TESTEMUNHA",
        label: "CPF",
        type: "text",
        required: true,
        mask: "cpf",
      },
      { id: "EMAIL_TESTEMUNHA", label: "Email", type: "email", required: true },
    ],
  },

  {
    sectionId: "tipo-imovel",
    sectionLabel: "Tipo de Imóvel",
    type: "conditional",
    groupKey: "tipo_imovel",
    requireTypeSelection: true,
    options: {
      casa: [
        { id: "ENDERECO_IMOVEL", label: "Endereço", type: "text" },
        { id: "NUMERO_IMOVEL", label: "Número", type: "text" },
        { id: "BAIRRO_IMOVEL", label: "Bairro", type: "text" },
        { id: "MUN_IMOVEL", label: "Município", type: "text" },
        { id: "AREA_CONSTRUIDA", label: "Área Construída", type: "text" },
        { id: "AREA_TERRENO", label: "Área do Terreno", type: "text" },
        { id: "DESCRICAO_IMOVEL", label: "Descrição do Imóvel", type: "text" },
        { id: "MAT_IMOVEL", label: "Matrícula", type: "text" },
        { id: "N_CARTORIO", label: "Cartório", type: "text" },
        { id: "MUN_CARTORIO", label: "Município do Cartório", type: "text" },
      ],

      apartamento: [
        { id: "ANDAR_AP", label: "Andar", type: "text" },
        { id: "VAGA_GARAGEM", label: "Vagas de Garagem", type: "text" },
        { id: "NOME_COND", label: "Condomínio", type: "text" },
        { id: "MUN_IMOVEL", label: "Município", type: "text" },
        { id: "MAT_IMOVEL", label: "Matrícula", type: "text" },
        { id: "N_CARTORIO", label: "Cartório", type: "text" },
        { id: "MUN_CARTORIO", label: "Município do Cartório", type: "text" },
      ],

      galpao: [
        { id: "ENDERECO_IMOVEL", label: "Endereço", type: "text" },
        { id: "BAIRRO_IMOVEL", label: "Bairro", type: "text" },
        { id: "MUN_IMOVEL", label: "Município", type: "text" },
        { id: "UF_IMOVEL", label: "UF", type: "text" },
        { id: "AREA_TOTAL", label: "Área Total (m²)", type: "text" },
        { id: "DESCRICAO_IMOVEL", label: "Descrição do Imóvel", type: "text" },
        { id: "MAT_IMOVEL", label: "Matrícula", type: "text" },
        { id: "N_CARTORIO", label: "Cartório", type: "text" },
        { id: "MUN_CARTORIO", label: "Município do Cartório", type: "text" },
      ],

      lote: [
        { id: "ENDERECO_IMOVEL", label: "Endereço", type: "text" },
        { id: "BAIRRO_IMOVEL", label: "Bairro", type: "text" },
        { id: "MUN_IMOVEL", label: "Município", type: "text" },
        { id: "UF_IMOVEL", label: "UF", type: "text" },
        { id: "AREA_TOTAL", label: "Área Total (m²)", type: "text" },
        { id: "DESCRICAO_IMOVEL", label: "Descrição do Imóvel", type: "text" },
        { id: "MAT_IMOVEL", label: "Matrícula", type: "text" },
        { id: "N_CARTORIO", label: "Cartório", type: "text" },
        { id: "MUN_CARTORIO", label: "Município do Cartório", type: "text" },
      ],

      rural: [
        { id: "LOCALIDADE_IMOVEL", label: "Localidade", type: "text" },
        { id: "MUN_IMOVEL", label: "Município", type: "text" },
        { id: "UF_IMOVEL", label: "UF", type: "text" },
        { id: "AREA_TOTAL", label: "Área Total", type: "text" },
        { id: "UNIDADE_AREA", label: "Unidade de Área", type: "text" },
        { id: "DESCRICAO_IMOVEL", label: "Descrição do Imóvel", type: "text" },
        { id: "MAT_IMOVEL", label: "Matrícula", type: "text" },
        { id: "N_CARTORIO", label: "Cartório", type: "text" },
        { id: "MUN_CARTORIO", label: "Município do Cartório", type: "text" },
        { id: "CCIR_IMOVEL", label: "CCIR", type: "text" },
      ],

      salacomercial: [
        { id: "ENDERECO_IMOVEL", label: "Endereço", type: "text" },
        { id: "BAIRRO_IMOVEL", label: "Bairro", type: "text" },
        { id: "MUN_IMOVEL", label: "Município", type: "text" },
        { id: "UF_IMOVEL", label: "UF", type: "text" },
        { id: "AREA_TOTAL", label: "Área Total (m²)", type: "text" },
        { id: "DESCRICAO_IMOVEL", label: "Descrição do Imóvel", type: "text" },
        { id: "MAT_IMOVEL", label: "Matrícula", type: "text" },
        { id: "N_CARTORIO", label: "Cartório", type: "text" },
        { id: "MUN_CARTORIO", label: "Município do Cartório", type: "text" },
      ],
    },
  },

  {
    sectionId: "dados-autorizacao",
    sectionLabel: "Modalidade, prazo e comissão",
    fields: [
      {
        id: "EXCLUSIVIDADE",
        label: "Exclusividade",
        type: "select",
        required: true,
        options: [
          { value: "exclusividade", label: "Exclusividade" },
          { value: "sem_exclusividade", label: "Sem exclusividade" },
        ],
        placeholder: "Selecione",
      },
      {
        id: "PRAZO_AUTORIZACAO",
        label: "Prazo da autorização (meses)",
        type: "number",
        required: true,
        min: 1,
        max: 1000,
        step: 1,
      },
      {
        id: "COMISSAO",
        label: "Comissão (%)",
        type: "text",
        required: true,
        mask: "decimal_br",
      },
    ],
  },

  {
    sectionId: "dados-contrato",
    sectionLabel: "Assinatura",
    fields: [
      {
        id: "CIDADE_ASSINATURA",
        label: "Cidade da assinatura",
        type: "text",
      },
      {
        id: "DATA_ASSINATURA",
        label: "Data da assinatura",
        type: "date",
      },
    ],
  },
];

export default autorizacaoVendaImovelFormSchema;
